export const API_URL='https://devtimbrado.misfacturas.mx/app/'
export const WS_URL='https://devtimbrado.misfacturas.mx/'
/*export const API_URL='http://localhost:8081/app/'
export const WS_URL='http://localhost:8081/'*/